module.exports = __webpack_public_path__ + "static/media/Text summary.78d2e99c.svg";